/**
 * CRASH-1458 — recarga controlada quando a aba pede um pedaço (chunk) que o
 * deploy novo já apagou.
 *
 * Uma aba aberta antes do deploy guarda os nomes antigos dos pedaços
 * (`InsightsArtifact-BM55GkAR.js`). Ao abrir o painel depois do deploy, o
 * import falha para sempre: `React.lazy` guarda a rejeição e nenhuma nova
 * tentativa conserta. A única saída é recarregar a página — e isso tem de
 * acontecer sozinho, mas UMA vez por janela: se o servidor continuar sem o
 * arquivo, recarregar de novo seria um laço. Fora da janela, a fronteira mostra
 * o botão "Recarregar" e a pessoa decide.
 */
const CHAVE = 'axiomgo:recarga-por-pedaco-velho'
export const JANELA_DA_RECARGA_MS = 60_000

const FALHA_DE_PEDACO =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i

export function ehFalhaDePedacoVelho(error: unknown): boolean {
  return error instanceof TypeError && FALHA_DE_PEDACO.test(error.message)
}

/** Recarrega se não recarregou por este motivo nos últimos 60 s. Devolve se recarregou. */
export function recarregaPorPedacoVelho(
  agora: number = Date.now(),
  recarregar: () => void = () => window.location.reload(),
): boolean {
  try {
    const ultima = Number(sessionStorage.getItem(CHAVE))
    if (ultima && agora - ultima < JANELA_DA_RECARGA_MS) return false
    sessionStorage.setItem(CHAVE, String(agora))
  } catch {
    // Sem onde anotar a recarga não há freio contra laço: fica no botão manual.
    return false
  }
  recarregar()
  return true
}

/**
 * O Vite dispara `vite:preloadError` quando o pré-carregamento de um pedaço
 * falha. Recarregando, o erro não precisa chegar à tela (`preventDefault`);
 * dentro da janela, o erro segue para a fronteira, que oferece o botão.
 */
export function instalaRecargaPorPedacoVelho(
  alvo: Window = window,
  recarregar?: () => void,
): () => void {
  const aoFalhar = (evento: Event) => {
    if (recarregaPorPedacoVelho(Date.now(), recarregar)) evento.preventDefault()
  }
  alvo.addEventListener('vite:preloadError', aoFalhar)
  return () => alvo.removeEventListener('vite:preloadError', aoFalhar)
}
